import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import { fg, featureGateKeys } from '@app/feature-gates';

import { ProductFilter } from './ProductFilter';
import { StatusFilter } from './StatusFilter';
import { ChangeTypeFilter } from './ChangeTypeFilter';
import { ImpactRatingFilter } from './ImpactRatingFilter';
import { TagFilter } from './TagFilter';
import { SearchInput } from './SearchInput';
import { ApplyButton } from './ApplyButton';
import { ResetButton } from './ResetButton';
import { DateRangeFilter } from './DateRangeFilter';

const filterContainerStyles = xcss({
  display: 'flex',
  gap: 'space.100',
  flexWrap: 'nowrap',
  alignItems: 'center',
  overflowX: 'auto',
});

interface AppUpdatesFiltersProps {}

export const AppUpdatesFilters: React.FC<AppUpdatesFiltersProps> = () => {
  return (
    <Box xcss={filterContainerStyles} testId="app-updates-table-filters-testid">
      <SearchInput />
      <DateRangeFilter />
      <ProductFilter />
      <StatusFilter />
      <ChangeTypeFilter />
      {fg(featureGateKeys.aiImpactAndContextTags) && <ImpactRatingFilter />}
      {fg(featureGateKeys.aiImpactAndContextTags) && <TagFilter />}
      <ApplyButton />
      <ResetButton />
    </Box>
  );
};

export default AppUpdatesFilters;
